// New Listings
export const QP_NEW_LISTINGS = 'latest';
export const QP_NEW_LISTINGS_VALUE_ENABLED = 'true';

// Page size
export const QP_PAGE_SIZE = 'pageSize';
export const QP_PAGE_SIZE_VALUE_DEFAULT = 60;
export const QP_PAGE_SIZE_VALUE_MAX = 120;

// Page count
export const QP_PAGE = 'page';

// Rooms
export const QP_ROOMS = 'rooms';

// Content Module Preview ID
export const QP_CONTENT_MODULE_ID = '_content:modules';
